import { useState, useEffect, useLayoutEffect, memo } from 'react';
import { useDispatch } from 'react-redux';
import {
  HideGlobalLoading,
  ShowGlobalLoading,
  UpdateAppSubHeaderTitle,
} from '../../redux/actions/UiActions';
import {
  Container,
  TopContainer,
  ProfileImage,
  Title,
  ButtonContainer,
  UserDataContainer,
  Column,
  ElementDivider,
  ButtonSaveContainer,
} from './styles/UserValidation';
import {
  BodyText,
  MediumHeightDivider,
  SmallHeightDivider,
  StyledButton,
  StyledButtonOutlined,
} from '../../theme/Styles';
import TextInformation from '../../components/TextInformation/TextInformation';
import { Grid } from '@mui/material';
import { useFormik } from 'formik';
import TextField from '../../components/TextField/TextField';
import Select from '../../components/Select/Select';
import {
  FormEmailSchema,
  FormPasswordSchema,
  FormRegisterExtenal,
  FormRegisterExtenalSchema,
  FormSchema,
  FormUserExtenal,
  FormUserExtenalSchema,
} from './UserValidationConstants';
import apiCall from '../../services/ApiServerCall';
import FormModal from '../../components/FormModal/FormModal';
import {
  modifyEmail,
  modifyPassword,
  modifyUserData,
} from '../../api/myConfiguration';
import { useSnackbar } from 'notistack';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { stringToDominicanCedula } from '../../utilities/functions/FormatterUtil';
import {
  getUser,
  RegisterUserExternal,
  ValidateComplete,
} from '../../api/Auth';
import { useTranslation } from 'react-i18next';
import PhoneTextField from '../../components/PhoneTextField/PhoneTextField';
import { cleanStringFromNumbers } from '../../utilities/functions/NumberUtil';
import LocalStorageService from '../../services/LocalStorageService';
import { getServiceDescription } from '../../api/ServiceDescription';
import { useHistory, useParams } from 'react-router';

function UserValidation() {
  const [t, i18n] = useTranslation('configuration');
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  let { serviceID } = useParams();
  const history = useHistory();
  const [userImage, setUserImage] = useState('');

  const [provincesData, setProvincesData] = useState([]);
  const [municipalitiesData, setMunicipalitiesData] = useState([]);
  const [sectorsData, setSectorsData] = useState([]);

  const [openUserExternalModal, setOpenUserExternalModal] = useState(false);
  const [openRegisterExternalModal, setOpenRegisterExternalModal] =
    useState(false);
  const [openModifyEmailModal, setOpenModifyEmailModal] = useState(false);

  const mutation = useMutation(ValidateComplete);

  const { isLoading, error, data, isFetching } = useQuery(['userData'], () =>
    getUser()
  );

  const userData = queryClient.getQueryData(['userData']);
  const { data: serviceDescription, isLoading: serviceDescriptionIsLoading } =
    useQuery(['serviceDescription', serviceID], async () => {
      try {
        dispatch(ShowGlobalLoading('Cargando'));
        const response = await getServiceDescription(serviceID);
        dispatch(HideGlobalLoading());
        return response;
      } catch (error) {
        // history.push('/app/home');
        dispatch(HideGlobalLoading());
      }
    });

  const formikUserExternalChange = useFormik({
    initialValues: {
      password: '',
      new_password_confirmation: '',
    },
    validationSchema: FormUserExtenalSchema,
    onSubmit: (values) => {
      validateUserExternal(values);
    },
  });

  const formikUserRegisterChange = useFormik({
    initialValues: {
      password: '',
      new_password_confirmation: '',
    },
    validationSchema: FormRegisterExtenalSchema,
    onSubmit: (values) => {
      registerUserExternal(values);
    },
  });

  //case 3
  const handleUserExternalModal = () => {
    formikUserExternalChange.resetForm();
    setOpenUserExternalModal(!openUserExternalModal);
  };

  //case 2
  const handleUserRegisterExternalModal = () => {
    formikUserRegisterChange.resetForm();
    setOpenRegisterExternalModal(!openRegisterExternalModal);
  };

  const validateUserExternal = async (formData) => {
    let link_external;
    const dataUserExternal = {
      userPassword: formData.new_password_confirmation,
      provider: serviceDescription.provider,
    };

    mutation.mutate(dataUserExternal, {
      onSuccess: (data) => {
        if (data.data.success) {
          enqueueSnackbar(data.data.message, {
            variant: 'success',
          });
          queryClient.invalidateQueries(['serviceDescription', serviceID]);
          link_external = data.data.link_external;

          handleUserExternalModal();
          setTimeout(() => {
            history.push(`/app/allServices`);
          }, 1000);
          setTimeout(() => {
            window.open(link_external, '_blank');
          }, 2000);
        } else {
          enqueueSnackbar(data.data.message, { variant: 'error' });
        }
      },
    });
  };

  const registerUserExternal = async (formData) => {
    let link_external;
    const dataRegisterUserExternal = {
      userPassword: formData.new_password_confirmation,
      provider: serviceDescription.provider,
    };

    try {
      const response = await RegisterUserExternal(dataRegisterUserExternal);
      link_external = link_external = response.data.link_external;
      if (response.data.success) {
        enqueueSnackbar(response.data.message, {
          variant: 'success',
        });

        handleUserRegisterExternalModal();
        setTimeout(() => {
          history.push(`/app/allServices`);
        }, 1000);
      } else {
        enqueueSnackbar(response.data.message, { variant: 'error' });
        handleUserRegisterExternalModal();
      }
    } catch (error) {
      enqueueSnackbar('Ha sucedido un error intentelo mas tarde', {
        variant: 'error',
      });
    }
  };

  useLayoutEffect(() => {
    //UPDATE APP HEADER SUBTITLE
    setUserImage(LocalStorageService.getItem('profile_img'));
    dispatch(
      UpdateAppSubHeaderTitle(
        `${serviceDescription?.link_external_provider !== null &&
          serviceDescription?.validationExternalProvider != null
          ? 'Confirmar Acceso a prodominicana'
          : 'Registrar Usuario en ogtic '
        } `
      )
    ); // TITLE OF SUBHEADER APP
  }, []);

  useEffect(() => { }, [i18n.language, serviceDescription, userData]);

  //i18n.language

  return (
    <Container>
      <TopContainer>
        <UserDataContainer>
          <ProfileImage src={userImage} />
          <ElementDivider />
          <div>
            {/*<Title>{t('Username')}</Title>*/}
            {/*<BodyText>{t('Cedula')}</BodyText>*/}

            <Title>
              {userData &&
                userData.payload.name +
                ' ' +
                userData.payload.first_last_name +
                ' ' +
                userData.payload.second_last_name}
            </Title>
            <BodyText>
              {t('Cedula')}:{' '}
              <strong>
                {userData &&
                  stringToDominicanCedula(userData.payload.citizen_id)}
              </strong>
            </BodyText>
            {/* <BodyText>{t('LastModification')}</BodyText> */}
            <SmallHeightDivider />
          </div>
        </UserDataContainer>
        <Column>
          {serviceDescription?.link_external_provider !== null &&
            serviceDescription?.validationExternalProvider != null ? (
            <ButtonContainer>
              <StyledButtonOutlined
                variant='outlined'
                onClick={handleUserExternalModal}
              >
                Confirmar Acceso
                {/* t('ChangePassword')*/}
              </StyledButtonOutlined>
            </ButtonContainer>
          ) : (
            <ButtonContainer>
              <StyledButtonOutlined
                variant='outlined'
                onClick={handleUserRegisterExternalModal}
              >
                Registrar Usuario
                {/* t('ChangePassword')*/}
              </StyledButtonOutlined>
            </ButtonContainer>
          )}
          <MediumHeightDivider />
        </Column>
      </TopContainer>
      {serviceDescription?.link_external_provider !== null &&
        serviceDescription?.validationExternalProvider != null ? (
        <FormModal
          onClose={handleUserExternalModal}
          open={openUserExternalModal}
          // title={t('modifypassword')}...
          title='Por favor introducir la contraseña'
        >
          <SmallHeightDivider />
          <Grid
            alignItems='flex-start'
            justifyContent='center'
            container
            direction='row'
            x
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            <Grid item xs={12} sm={12} md={12}>
              <TextField
                // title={t('NewPassword')}
                title='Contraseña'
                type='password'
                id='password'
                value={formikUserExternalChange.values.password}
                onChange={formikUserExternalChange.handleChange}
                onBlur={formikUserExternalChange.handleBlur}
                error={
                  formikUserExternalChange.touched.password &&
                  Boolean(formikUserExternalChange.errors.password)
                }
                helperText={
                  formikUserExternalChange.touched.password &&
                  formikUserExternalChange.errors.password
                }
                required
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <TextField
                // title={t('Repeatnewpassword')}
                title='Repetir Contraseña'
                type='password'
                id='new_password_confirmation'
                value={
                  formikUserExternalChange.values.new_password_confirmation
                }
                onChange={formikUserExternalChange.handleChange}
                onBlur={formikUserExternalChange.handleBlur}
                error={
                  formikUserExternalChange.touched.new_password_confirmation &&
                  Boolean(
                    formikUserExternalChange.errors.new_password_confirmation
                  )
                }
                helperText={
                  formikUserExternalChange.touched.new_password_confirmation &&
                  formikUserExternalChange.errors.new_password_confirmation
                }
                required
              />
            </Grid>
          </Grid>

          <SmallHeightDivider />
          <SmallHeightDivider />

          <ButtonSaveContainer>
            <StyledButton
              onClick={() => formikUserExternalChange.handleSubmit()}
            >
              {t('CONFIRM')}
            </StyledButton>
          </ButtonSaveContainer>

          <SmallHeightDivider />
          <SmallHeightDivider />
        </FormModal>
      ) : (
        <FormModal
          onClose={handleUserRegisterExternalModal}
          open={openRegisterExternalModal}
          // title={t('modifypassword')}...
          title='Por favor introducir la contraseña '
        >
          <SmallHeightDivider />
          <Grid
            alignItems='flex-start'
            justifyContent='center'
            container
            direction='row'
            x
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            <Grid item xs={12} sm={12} md={12}>
              <TextField
                // title={t('NewPassword')}
                title='Contraseña'
                type='password'
                id='password'
                value={formikUserRegisterChange.values.password}
                onChange={formikUserRegisterChange.handleChange}
                onBlur={formikUserRegisterChange.handleBlur}
                error={
                  formikUserRegisterChange.touched.password &&
                  Boolean(formikUserRegisterChange.errors.password)
                }
                helperText={
                  formikUserRegisterChange.touched.password &&
                  formikUserRegisterChange.errors.password
                }
                required
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <TextField
                // title={t('Repeatnewpassword')}
                title='Repetir Contraseña'
                type='password'
                id='new_password_confirmation'
                value={
                  formikUserRegisterChange.values.new_password_confirmation
                }
                onChange={formikUserRegisterChange.handleChange}
                onBlur={formikUserRegisterChange.handleBlur}
                error={
                  formikUserRegisterChange.touched.new_password_confirmation &&
                  Boolean(
                    formikUserRegisterChange.errors.new_password_confirmation
                  )
                }
                helperText={
                  formikUserRegisterChange.touched.new_password_confirmation &&
                  formikUserRegisterChange.errors.new_password_confirmation
                }
                required
              />
            </Grid>
          </Grid>

          <SmallHeightDivider />
          <SmallHeightDivider />

          <ButtonSaveContainer>
            <StyledButton
              onClick={() => formikUserRegisterChange.handleSubmit()}
            >
              {t('CONFIRM')}
            </StyledButton>
          </ButtonSaveContainer>

          <SmallHeightDivider />
          <SmallHeightDivider />
        </FormModal>
      )}

      <MediumHeightDivider />

      {/* <ButtonSaveContainer>
        <StyledButtonOutlined variant='outlined' onClick={formik.handleSubmit}>
          {t('save')}
        </StyledButtonOutlined>
      </ButtonSaveContainer>*/}
      <MediumHeightDivider />
    </Container>
  );
}
export default memo(UserValidation);
